import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Ruter hvor vi vil bevare scroll-position ved tilbage-navigation
const PRESERVE_SCROLL_ROUTES = ["/biler"];

const shouldPreserve = (pathname: string) =>
  PRESERVE_SCROLL_ROUTES.some((p) => pathname === p || pathname.startsWith(p + "?"));

const storageKey = (pathname: string) => `scroll:${pathname}`;

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  const navType = useNavigationType(); // POP = back/forward
  const prevPath = useRef<string | null>(null);

  // Gem scroll-position for den side vi forlader, hvis den er "preserve"
  useEffect(() => {
    return () => {
      if (prevPath.current && shouldPreserve(prevPath.current)) {
        try {
          sessionStorage.setItem(storageKey(prevPath.current), String(window.scrollY));
        } catch {
          /* noop */
        }
      }
    };
  }, [pathname]);

  useEffect(() => {
    const key = storageKey(pathname);
    let restored = false;
    if (navType === "POP" && shouldPreserve(pathname)) {
      try {
        const saved = sessionStorage.getItem(key);
        if (saved) {
          const y = parseInt(saved, 10);
          if (!Number.isNaN(y)) {
            // Vent et tick så listen er renderet
            requestAnimationFrame(() => window.scrollTo({ top: y, left: 0 }));
            restored = true;
          }
        }
      } catch {
        /* noop */
      }
    }
    if (!restored) {
      window.scrollTo({ top: 0, left: 0 });
    }
    prevPath.current = pathname;
    // search bevidst inkluderet så vi opdaterer prevPath på samme rute med nye filtre
  }, [pathname, search, navType]);

  return null;
};

export default ScrollToTop;
